<template>
  <div class="app-container">
    <router-view v-slot="{ Component }">
      <component :is="Component" @login-success="handleLogin" @logout="handleLogout" />
    </router-view>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { usePlatformStore } from '@/composables/usePlatformStore';

const router = useRouter();
const { login, logout } = usePlatformStore();

const handleLogin = async ({ role, auth = null }) => {
  await login(role, auth);
  router.push('/platform/templates');
};

const handleLogout = () => {
  logout();
  router.push('/login');
};
</script>

<style>
.app-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
